import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import {
    BaseComponent,
    BottoneAPI,
    ChiamaAPI,
    Contesto,
    FideTassiProductsTab,
    Trad
} from '../components/';

interface IFideTassiState {
    Dati: DatiFide.CRisAPIListaFideTassi;
}

export interface IFideTassiProduct extends DatiFide.CDatiFideTassi {
    Index: number;
}

export class FideTassi extends BaseComponent<Glob.IRouteGlobaleProps, IFideTassiState> {
    private ID_Binder: number;
    private infoContesto: Dati.InfoContesto[] = [];

    public constructor(props: any) {
        super(props);
        this.ID_Binder = (this.props.match.params as any).ID_Binder;
        this.state = { Dati: new DatiFide.CRisAPIListaFideTassi() };
        this.OnChange = this.OnChange.bind(this);
        this.OnChangeTipoDurata = this.OnChangeTipoDurata.bind(this);
        this.OnChangeDurata = this.OnChangeDurata.bind(this);
        this.OnChangeSommaGarantitaDa = this.OnChangeSommaGarantitaDa.bind(this);
        this.OnChangeSommaGarantitaA = this.OnChangeSommaGarantitaA.bind(this);
        this.OnBlurRiordina = this.OnBlurRiordina.bind(this);
        this.OnAddProduct = this.OnAddProduct.bind(this);
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? ": " + dati.ErrTesti[0] : ""));
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("TASSI"), Trad.Trad("Tassi salvati correttamente"));
        }
    }

    private OnInvioSalva(sender: BottoneAPI): Dati.CIngrAPILista<DatiFide.CDatiFideTassi> {
        let R = new Dati.CIngrAPILista<DatiFide.CDatiFideTassi>();
        R.Dati = this.state.Dati.Dati;
        return R;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnChangeTipoDurata(e: string, valore?: any): any {
        let Dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;
        let indice: number = Number(e.split(".")[1].toString());
        for (let i: number = 0; i < Dati.Dati.length; i++) {
            if (Dati.Dati[i].ID_BinderCompagnia == Dati.Dati[indice].ID_BinderCompagnia
                && Dati.Dati[i].ID_TipoProdotto == Dati.Dati[indice].ID_TipoProdotto) {
                Dati.Dati[i].ID_TipoDurata = valore;
            }
        }

        this.setState({ Dati: Dati });
        return true;
    }

    protected OnChangeSommaGarantitaDa(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof (e) != "string") {
            let Dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;
            let Indice: number = Number(e.currentTarget.name.split(".")[1].toString());
            Dati.Dati[Indice].SommaGarantitaDa = e.currentTarget.value;
            for (let I: number = 0; I < Dati.Dati.length; I++) {
                if (Dati.Dati[I].ID_BinderCompagnia == Dati.Dati[Indice].ID_BinderCompagnia
                    && Dati.Dati[I].ID_TipoProdotto == Dati.Dati[Indice].ID_TipoProdotto) {
                    if (I == Indice - 1) { //La riga precedente
                        Dati.Dati[I].SommaGarantitaA = Dati.Dati[Indice].SommaGarantitaDa;
                    }
                }
            }

            this.setState({ Dati: Dati });
        }
    }

    protected OnChangeSommaGarantitaA(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof (e) != "string") {
            let Dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;
            let Indice: number = Number(e.currentTarget.name.split(".")[1].toString());
            Dati.Dati[Indice].SommaGarantitaA = e.currentTarget.value;
            for (let I: number = 0; I < Dati.Dati.length; I++) {
                if (Dati.Dati[I].ID_BinderCompagnia == Dati.Dati[Indice].ID_BinderCompagnia
                    && Dati.Dati[I].ID_TipoProdotto == Dati.Dati[Indice].ID_TipoProdotto) {
                    if (I == Indice + 1) { //La riga successiva
                        Dati.Dati[I].SommaGarantitaDa = Dati.Dati[Indice].SommaGarantitaA;
                    }
                }
            }

            this.setState({ Dati: Dati });
        }
    }

    protected OnChangeDurata(e: React.FormEvent<any>): any {
        let Dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;
        let indice: number = Number(e.currentTarget.name.split(".")[1].toString());
        for (let i: number = 0; i < Dati.Dati.length; i++) {
            if (Dati.Dati[i].ID_BinderCompagnia == Dati.Dati[indice].ID_BinderCompagnia
                && Dati.Dati[i].ID_TipoProdotto == Dati.Dati[indice].ID_TipoProdotto) {
                Dati.Dati[i].Durata = e.currentTarget.value;
            }
        }

        this.setState({ Dati: Dati });
        return true;
    }

    private OnBlurRiordina() {
        let dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;

        if (dati && dati.Dati) {
            dati.Dati.sort((a, b) => (a.ID_BinderCompagnia - b.ID_BinderCompagnia
                || a.ID_TipoProdotto - b.ID_TipoProdotto
                || a.SommaGarantitaDa - b.SommaGarantitaDa
            ));

            this.setState({ Dati: dati });
        }
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPIListaFideTassi, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Dati: dati }, () => this.OnBlurRiordina());
        }

        let nav: React.ReactNode[] = [];
        let content: React.ReactNode[] = [];
        let grouped: IFideTassiProduct[][] = dati.Dati.reduce((total: any, current, index) => {
            let last = total[total.length - 1];
            if (!last || last[0].ID_BinderCompagnia !== current.ID_BinderCompagnia) {
                total.push([{...current, Index: index}]);
            } else {
                last.push({...current, Index: index});
            }
            return total;
        }, []);

        grouped.forEach((group, i) => {
            const className = i == 0 ? ' active' : '';

            nav.push(
                <li className="nav-item" key={i}>
                    <a className={`nav-link${className}`} data-toggle="tab" href="#" data-target={`#kt_tabs_${i}`}>{group[0].Compagnia}</a>
                </li>
            );
            content.push(
                <div className={`tab-pane${className}`} id={`kt_tabs_${i}`} role="tabpanel" key={i}>
                    <FideTassiProductsTab
                        Products={group}
                        OnAddProduct={this.OnAddProduct}
                        OnBlurRiordina={this.OnBlurRiordina}
                        OnChange={this.OnChange}
                        OnChangeDurata={this.OnChangeDurata}
                        OnChangeSommaGarantitaA={this.OnChangeSommaGarantitaA}
                        OnChangeSommaGarantitaDa={this.OnChangeSommaGarantitaDa}
                        OnChangeTipoDurata={this.OnChangeTipoDurata}
                        DurationTypes={dati.Tipi['TipiDurate']}
                    />
                </div>
            );
        });

        return (
            <>
                <ul className="nav nav-tabs" role="tablist">{nav}</ul>
                <div className="tab-content">{content}</div>
            </>
        );
    }

    OnAddProduct(Gruppi: IFideTassiProduct) {
        const dati: DatiFide.CRisAPIListaFideTassi = this.state.Dati;
        const NewField = new DatiFide.CDatiFideTassi(Gruppi.Compagnia, Gruppi.ID_Binder, Gruppi.ID_BinderCompagnia,
            Gruppi.ID_TipoRamo, Gruppi.ID_TipoProdotto, Gruppi.ID_TipoDurata,
            Gruppi.Durata, Gruppi.TipoRamo, Gruppi.TipoProdotto, Gruppi.LimitePerSingoloProdotto,
            Gruppi.LimiteTassoMinimo, Gruppi.SommaGarantitaA, Gruppi.LimitePerSingoloProdotto);
    
        dati.Dati.push({ ...NewField });
        this.setState({ Dati: dati }, () => this.OnBlurRiordina());
    }

    public render() {
        if (!this.ControlloAutorizzazione("FideTassiController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }
        this.infoContesto = [];
        this.infoContesto.push(new Dati.InfoContesto(Trad.Trad("Binder"), "/api/binder/Contesto?ID_Binder=" + (this.props.match.params as any).ID_Binder, "/binder/" + (this.props.match.params as any).ID_Binder));
        return <div>
            <Contesto Id="InfoContesto" Info={this.infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-tachometer-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Tassi")}
                            </h3>
                        </div>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <ChiamaAPI URL={"/api/fidetassi/?id_binder=" + this.ID_Binder} Aggiornare={1} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} />
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Default Testo={Trad.Trad("Salva")} URL="/api/fidetassi/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/form/FideTassi.tsx